import { ObjectStorage } from 'console/shared/api/object-storage';
import { ThemeType } from 'console/theme/types';
export const getSelectedTheme = () => (ObjectStorage.get(window.localStorage, 'ui_settings') ?? {}).themeType ??
    ThemeType.SYSTEM;
export const saveToLocalStorage = (key, data) => {
    localStorage.setItem(key, JSON.stringify(data));
};
